/** Exact CRM company comparison: collapse NFC/case/whitespace, retain legal forms. */
export function normaliseCompanyName(raw) {
  const collapsed = raw?.normalize("NFC").trim().replace(/\s+/g, " ").toLowerCase();
  return collapsed || null;
}
